import React, {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState
} from 'react';
import useGetToken from 'hooks/Login/useGetToken';
import httpMethod from '../services/update2025/httpMethod';
import BaseUrl from '../constant/baseUrl';
import useGetProfile from '../hooks/Login/useGetProfile';

const AuthenticationContext = createContext({
    loading: false,
    isLogged: false,
    user: null,
    login: ({ code, redirect_uri }) => {},
    logout: () => {}
});

export const useAuth = () => useContext(AuthenticationContext);

export default function AuthenticationProvider({ children }) {
    const [token, setToken] = useState(httpMethod.getTokenStorage());
    const [user, setUser] = useState(httpMethod.getUserStorage());
    const [isLogging, setIsLogging] = useState(false);

    const { getToken } = useGetToken();
    const { getProfile } = useGetProfile();

    const onSuccessProfile = (profile) => {
        setUser(profile);
        httpMethod.saveUserStorage(profile);
    };
    const redirect = () => {
        // quay về root trong app NHƯNG giữ base PUBLIC_URL (vd /admin), nếu không asset
        // tương đối (theme.css, logo trong public/assets) sẽ 404 và mất theme/icon.
        // App sẽ tự điều hướng tới menu đầu tiên user có quyền sau khi nạp xong authorities.
        window.location.href = `${process.env.PUBLIC_URL}/#/`;
    };
    const onSuccessToken = async (data) => {
        const accessToken = data.access_token;
        if (accessToken) {
            setIsLogging(false);
            setToken(accessToken);
            await httpMethod.attachTokenToHeader(accessToken);
            await httpMethod.saveTokenStorage(data);
            // sau khi có token, gọi lấy profile. Profile chỉ để hiển thị thông tin user,
            // KHÔNG phải điều kiện đăng nhập -> nếu lỗi (vd userinfo lỡ trả 401 ngay sau
            // khi cấp token) thì vẫn coi như login thành công và đi tiếp.
            try {
                await getProfile({ onSuccess: onSuccessProfile });
            } catch (e) {
                // bỏ qua: đã có access_token hợp lệ
            }
            // redirect về trang chính
            await redirect();
        }
    };

    const login = useCallback(async ({ code, redirect_uri }) => {
        setIsLogging(true);
        getToken({ code, redirect_uri, onSuccess: onSuccessToken });
    }, []);

    const logout = useCallback(() => {
        httpMethod.clearStorage();
        window.localStorage.clear();
        window.sessionStorage.clear();
        window.location.reload();
        window.location.href = `${process.env.REACT_APP_IDP_SSO_URL}/api/idp/sso/login-actions/logout?client_id=${process.env.REACT_APP_IDP_CLIENT_ID}&redirect_uri=${encodeURIComponent(window.location.origin)}`;
    }, []);

    // attach token nếu refresh trang
    useEffect(() => {
        const stored = httpMethod.getTokenStorage();
        if (stored?.access_token) {
            httpMethod.attachTokenToHeader(stored.access_token);
        }
    }, []);

    const value = useMemo(
        () => ({
            loading: isLogging,
            isLogged: !!token,
            user,
            login,
            logout
        }),
        [token, user, isLogging, login, logout]
    );

    return (
        <AuthenticationContext.Provider value={value}>
            {children}
        </AuthenticationContext.Provider>
    );
}
